module.exports = __webpack_public_path__ + "img/unidad-super-computo-cca.8c99dc8d.jpg";